import axios from 'axios'
import Cookies from 'js-cookie'
import { Message } from 'element-ui'
import config from '../../../public/config/config'

const tokenKey = 'token'

const service = axios.create({
  baseURL: config.BASE_URL, // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 60000, // request timeout
  headers: {
    'Content-Type': 'application/json'
  }
})

// request interceptor
service.interceptors.request.use(
  config => {
    config.headers.token = Cookies.get(tokenKey)
    return config
  },
  error => {
    // do something with request error

    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
   */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    const res = response.data
    if (res.code === 401) {
      window.location.href = '/'
    } else {
      return response
    }
    // const res = response.data
    //
    // // if the custom code is not 20000, it is judged as an error.
    // if (res.code !== 200 && res.code !== 0) {
    //   Message({
    //     message: res.message || res.msg,
    //     type: 'error',
    //     duration: 3 * 1000
    //   })
    //   return Promise.reject(new Error(res.message || 'Error'))
    // } else {
    //   return res
    // }
  },
  error => {
    Message({
      message: '系统错误',
      type: 'error',
      duration: 3 * 1000
    })
    return Promise.reject(error)
  }
)

function get (uri, success, fail) {
  doPost(uri, undefined, success, fail)
}

function post (uri, data, success, fail) {
  doPost(uri, data, success, fail)
}

function doPost (uri, data, success, fail) {
  const requestObj = {
    url: config.BASE_URL + uri
  }
  if (data) {
    requestObj.data = data
    requestObj.method = 'POST'
  }
  service.request(requestObj).then(res => {
    success(res.data)
  }).catch(msg => {
    fail()
  })
}

export default {
  get: get,
  post: post,
  tokenKey: tokenKey
}
